import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos";
import { useState } from "react";
import axios from "axios";

export default function DictionarySearch() {
  const [keyword, setKeyword] = useState("comet");
  const [result, setResult] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [photos, setPhotos] = useState(null);
  const form = (
    <form className="form" onSubmit={handleSubmit}>
      <input
        type="search"
        onChange={handleKeywordChange}
        placeholder="Search definition"
        autoFocus={true}
        className="input"
      />
    </form>
  );

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    search();
  }

  function search() {
    const apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleResponse);
    setLoaded(true);
    const pexelsApiKey =
      "563492ad6f917000010000011869cfd27dc947b3bf1efb44f7af9182";
    const pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
    axios
      .get(pexelsApiUrl, {
        headers: { Authorization: `Bearer ${pexelsApiKey}` },
      })
      .then(handlePexelsResponse);
  }

  function handleResponse(response) {
    setResult(response.data[0]);
  }

  function handlePexelsResponse(response) {
    console.log(response.data);
    setPhotos(response.data.photos);
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        {form}
        <Results result={result} />
        <Photos photos={photos} keyword={keyword} />
      </div>
    );
  } else {
    search();
    return <div className="loading">Loading</div>;
  }
}
